import { createContext, useContext } from "react";

export const PortalCtx = createContext(null);
export const usePortal = () => useContext(PortalCtx);
